module.exports = __webpack_public_path__ + "banquet/components/AccountSettings/images/push_toggle.771540984fa7367d90fef8d5bab06ab5.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/AccountSettings/images/push_toggle.png
// module id = 1643
// module chunks = 1